<template>
  <div class="memu">
    <el-menu
      :default-active="$route.path"
      router
      unique-opened=true
      @close="handleClose"
      :default-openeds='openArr'
      >
      <el-menu-item index="/work-bench" >
        <img src="../../../assets/images/Homepage_con.png"/>
        <span slot="title" class="subMenu">工作台</span>
      </el-menu-item>

      <el-submenu index="1">
        <template slot="title">
          <img src="../../../assets/images/mseeage_icon.png"/>
          <span slot="title" class="subMenu">招商智投（普投）</span>
        </template>
        <el-menu-item index="/feedback">竞价</el-menu-item>
        <!--<el-menu-item index="/bai-list">百度留言</el-menu-item>-->
        <el-menu-item index="/info-list">信息流</el-menu-item>
        <el-menu-item index="/cpc-daily-statement">资源报表</el-menu-item>
        <el-menu-item index="/cpc-receive-list">接收报表</el-menu-item>
      </el-submenu>

      <el-submenu index="2"  >
        <template slot="title">
          <img src="../../../assets/images/ocpc_icon.png"/>
          <span slot="title" class="subMenu">招商智投（智投）</span>
        </template>
        <el-menu-item index="/resource">资源列表</el-menu-item>
        <el-menu-item index="/daily-statement">资源报表</el-menu-item>
        <el-menu-item index="/receive-list">接收报表</el-menu-item>
      </el-submenu>

      <el-menu-item index="/promote-data">
        <img src="../../../assets/images/extension_icon.png"/>
        <span slot="title" class="subMenu">推广管理</span>
      </el-menu-item>

      <!-- <el-menu-item index="/intel-analysis">
        <img src="../../../assets/images/analysis_icon.png"/>
        <span slot="title" class="subMenu">数据分析</span>
      </el-menu-item> -->

      <el-menu-item index="/shopping-mall" v-if="showQuDao">
        <img src="../../../assets/images/mall_icon.png"/>
        <span slot="title" class="subMenu">积分商城</span>
      </el-menu-item>

      <el-submenu index="3">
        <template slot="title">
          <img src="../../../assets/images/resources_icon.png"/>
          <span slot="title" class="subMenu">资源同步crm</span>
        </template>
        <el-submenu index="3-1">
          <template slot="title">ec</template>
          <el-menu-item index="/ec-setting">推送配置</el-menu-item>
          <el-menu-item index="/ec/data-dispose">话务排班</el-menu-item>
        </el-submenu>
        <el-submenu index="3-2">
          <template slot="title">励销</template>
          <el-menu-item index="/lxcrm-setting">推送配置</el-menu-item>
          <el-menu-item index="/lixiao/data-dispose">话务排班</el-menu-item>
        </el-submenu>
        <el-submenu index="3-3">
          <template slot="title">销帮帮</template>
          <el-menu-item index="/xbbcrm-setting">推送配置</el-menu-item>
          <el-menu-item index="/xbb/data-dispose">话务排班</el-menu-item>
        </el-submenu>
        <el-submenu index="3-4">
          <template slot="title">伙伴云</template>
          <el-menu-item index="/hby-setting">推送配置</el-menu-item>
          <el-menu-item index="/huoban/data-dispose">话务排班</el-menu-item>
        </el-submenu>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
  export default {
    props: ['openArr'],
    components: {},
    data () {
      return {
        curPage: '',
        isCollapse: false,
        opendsItem: [],
        showQuDao: true
      }
    },
    created () {
      if (window.location.host !== 'test-emcp.qudao51.com' && window.location.host !== 'www.qudao51.com') {
        this.showQuDao = false
      }
      if (window.location.host === 'localhost:8030') {
        this.showQuDao = true
      }
    },
    methods: {
      handleOpen (e, keyPath) {
        console.log(keyPath)
        // this.$emit('setOpenArr', e, keyPath)
      }
    }
  }
</script>

<style lang="scss">
  .el-menu-item.is-active,.el-menu-item:hover{
    background: #ebf5ff;
    color: #409EFF;
  }
  .el-submenu__title img,.el-menu-item img{
    margin-right:4px;
  }
</style>

<style scoped="scoped" lang="scss">
  @import '../../../assets/styles/_env.scss';
  .memu {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    .el-menu-vertical-demo {
      border: none;
      color: #303133;
    }
    .menu-icon-mr{margin-right:10px;}
    .el-submenu .el-menu-item{min-width:0;}
    .el-menu-vertical-demo .is-active{background:rgba(235,245,255,1);color: #303133;}
  }
</style>



// WEBPACK FOOTER //
// src/components/client/common/Menu.vue